<template>
  <div>
    <el-popover placement="right" width="400" trigger="hover">
      <div>
        <el-form label-width="80px" label-position="left">
          <el-form-item :label="item.name" v-for="(item, index) in config.pops" :key="index">
            <x-show v-model="value[item.key]" :type="item.type"></x-show>
          </el-form-item>
        </el-form>
      </div>
      <div slot="reference" class="ac">
        <el-form-item :label="item.name" v-for="(item, index) in config.shows" :key="index">
          <x-show v-model="value[item.key]" :type="item.type"></x-show>
        </el-form-item>
      </div>
    </el-popover>
  </div>
</template>

<script>
import XShow from './XShow.vue'

export default {
  components: { XShow },
  props: {
    value: {
      type: Array,
      default: null
    },
    config: {
      type: Object,
      default: null
    }
  },

  data() {
    return {}
  },

  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
